import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled from 'styled-components';
import { jsxs, jsx } from 'react/jsx-runtime';

var _templateObject;
const SvgComponent = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/jsxs("svg", {
    stroke: "currentColor",
    strokeWidth: 0,
    viewBox: "0 0 576 512",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    "aria-labelledby": titleId,
    ...props,
    children: [title ? /*#__PURE__*/jsx("title", {
      id: titleId,
      children: title
    }) : null, /*#__PURE__*/jsx("path", {
      d: "M106.617 319.475h266.16c5.95 0 10.738 4.79 10.738 10.739V372.4c0 5.95-4.789 10.739-10.738 10.739h-266.16c-5.949 0-10.738-4.79-10.738-10.739v-42.186c0-5.95 4.79-10.739 10.738-10.739zM521.9 432H54.1c-3.3 0-6-2.7-6-6V256h479.8v170c0 3.3-2.7 6-6 6zM54.1 80h467.8c3.3 0 6 2.7 6 6v42H48.1V86c0-3.3 2.7-6 6-6zm473.8-48H48.1C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48.1 48h479.8c26.6 0 48.1-21.5 48.1-48V80c0-26.5-21.5-48-48.1-48z",
      fill: "currentColor",
      stroke: "none"
    }), /*#__PURE__*/jsx("path", {
      d: "M227.547 278.56v143.96h202.252V278.56zm22 22h158.252v99.96H249.547z",
      fill: "#ec6730",
      stroke: "none"
    })]
  });
};
const IconCvv = /*#__PURE__*/styled(SvgComponent).withConfig({
  displayName: "Cvv__IconCvv",
  componentId: "sc-80hg0t-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: inline-flex;\n  vertical-align: middle;\n"])));

export { IconCvv };
